import {
  resourceState,
  resourceMutations,
  resourceGetters,
  resourceActions,
} from '@/store/utils/resource';
import { ACC_PRODUCTS } from '@/store/entities/schema_types';
import { accountAccProductsClient as client } from '@/api/clients';
import mapKeysToSnakeCase from '@/utils/map-keys-to-snake-case';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  getters: resourceGetters('accProducts'),
  actions: {
    ...resourceActions,
    async load(ctx, { id, query = {} }) {
      try {
        const { data, meta } = await client.list(id, query);

        const ids = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCTS, data },
          { root: true }
        );

        ctx.commit({
          type: 'setIdsByParent',
          parentId: id,
          ids,
        });

        return Promise.resolve({ ids, meta });
      } catch (error) {
        const { response } = error;

        return Promise.reject(response);
      }
    },
    async store(ctx, { id, formData }) {
      try {
        const response = await client.store(id, mapKeysToSnakeCase(formData));

        const accProductId = await ctx.dispatch(
          'entities/persistEntities',
          { type: ACC_PRODUCTS, data: response.data },
          { root: true }
        );

        return Promise.resolve(accProductId);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
